import Expert1 from '../img/dr-bev.jpg';
import Expert2 from '../img/dr-dianne.jpg';
import Expert3 from '../img/dr-philippa.jpg';
import Expert4 from '../img/dr-lisa.jpg';
import Expert5 from '../img/dr-rawiri.jpg';
import Expert6 from '../img/dr-jason.jpg';

const Panel = () =>{

    let panelArr = [
        {"img": Expert2, "name":"Dr Dianne Sika-Paotonu", "role":"Immunologist and senior lecturer in pathology and molecular medicine at the University of Otago, Wellington"},
        {"img": Expert3, "name":"Philippa Howden-Chapman (CNZM, QSO, RSNZ)", "role":"A professor of public health at the University of Otago, Wellington with expertise in housing, cities and health research"},
        {"img": Expert4, "name":"Dr Lisa Te Morenga, Ngāti Whātua Ōrākei, Te Uri o Hau, Ngāpuhi", "role":"Associate Professor in nutrition and Māori health, with a particular interest in addressing health inequities in Aotearoa"},
        {"img": Expert5, "name":"Dr Rawiri Jansen, Ngāti Raukawa", "role":"General practitioner and clinical director for a primary healthcare organisation"},
        {"img": Expert6, "name":"Dr Jason Gurney, Ngāpuhi", "role":"University of Otago, Wellington epidemiologist with expertise in cancer, other chronic conditions and health inequities between Māori and non-Māori"},
        {"img": Expert1, "name":"Dr Beverley Lawton (ONZM), Ngāti Porou", "role":"Professor in women's health and founder of Te Tātai Hauora o Hine — National Centre for Women’s Health Research Aotearoa"},
    ]
    return(
        <div className="panel-container">
        <span className="panel-container--title">An expert advisory panel supports the production of this project</span>
        <div className="panel-container--box">
            {panelArr.map((person,index)=>(
            <div key={index} className="panel-container--box---each">
                <div className="panel-container--box---each--img" style={{backgroundImage:`url(${person.img})`}}></div>
                {/* <div className="panel-container--box---each--img"></div> */}
                <div className="panel-container--box---each--infobox">
                    <p className="panel-container--box---each--infobox---name">{person.name}</p>
                    <p className="panel-container--box---each--infobox---role">{person.role}</p>
                </div>
            </div>
            ))} 
        </div>
    </div>
    )
}

export default Panel;
